namespace Nobox {
    export interface JoinAgentAndSentMsgClass {
        Agent?: ChatroomagentsRow;
        Msg?: ChatmessagesRow;
        RoomId?: number;
    }
}
